import { AppError } from './AppError';

/**
 * Raised for invalid user input at a form/DTO boundary.
 * Per the logging rules, validation errors are normal system behavior
 * and are logged at Debug/Info level, never at Error level.
 */
export class ValidationError extends AppError {
  public readonly fieldErrors: Readonly<Record<string, string>>;

  constructor(
    message: string,
    fieldErrors: Record<string, string> = {},
    options?: { cause?: unknown }
  ) {
    super('VALIDATION_ERROR', message, options);
    this.name = 'ValidationError';
    this.fieldErrors = fieldErrors;
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
